import React, { useEffect } from 'react';
import './InfoCard.css';
import ClickableText from '../ClickableText/ClickableText';

const InfoCard = ({ cardHeight, cardWidth, cardLabel, cardText, cardCount, cardDetails, clickableProject, clickableTag }) => {

    // const handleCardClick = (title) => {
    //     if (setSelectedProjectTitle && setUserModalOpen) {
    //         setSelectedProjectTitle(title); 
    //         setUserModalOpen(true);
    //     }     
    // };

    const renderComponent = () => {
        if (clickableProject) return <ClickableText clickableProject={clickableProject}/>
        if (clickableTag) return <ClickableText clickableTag={clickableTag}/>
        // if (condition2) return <Component2 />;
        // if (condition3) return <Component3 />;
        return ''
    };

    return (
        // <div className='infoCard' style={{ height: `${cardHeight}vw`, width: `${cardWidth}vw`}} onClick={() => setUserModalOpen(true)}>
        // <div className={setSelectedProjectTitle && setUserModalOpen ? 'infoCardClickable' : 'infoCard'} style={{ height: `${cardHeight}vw`, width: `${cardWidth}vw`}} onClick={() => handleCardClick(cardText)}>
        <div className='infoCard' style={{ height: `${cardHeight}vw`, width: `${cardWidth}vw`}}>
            <div className='contentContainer'>
                <p>{cardText ? cardText : ''}</p>
                {/* {clickableCardText ? <ClickableText clickableProject={clickableCardText}/> : ''} */}
                {renderComponent()}
                <div style={{display:'flex', flex: 'row', alignItems: 'center'}}>
                    <p style={{ color: 'rgb(90, 190, 164)'}}>{cardCount ? cardCount : ''}</p>
                    &nbsp;
                    {cardDetails ? <p>{cardCount < 2 ? cardDetails : cardDetails + 's'}</p> : ''}
                </div>
            </div>
            <div className='labelContainer'>
                <p>{cardLabel}</p>
            </div>
        </div>
    );
}

export default InfoCard;
